import { DISPLAY_DATE_FORMAT } from 'constants/dates';
import { addDays, format } from 'date-fns';
import { t } from 'i18next';

export const expirationDateToValidationRules = (
  expirationDateFrom?: string,
) => ({
  validate: (v: string | undefined) => {
    if (v && expirationDateFrom && new Date(v) < new Date(expirationDateFrom)) {
      return t('notBeforeDependentDate', {
        ns: 'validation',
        replace: {
          '0': format(
            addDays(new Date(expirationDateFrom), -1),
            DISPLAY_DATE_FORMAT,
          ),
        },
      });
    }
    return true;
  },
});

export const namedAccountValidationRules = {
  required: true,
  validate: (value: any) => {
    const hasNull = value.some((item: { id: null }) => item.id === null);
    if (hasNull && value.length > 1) {
      return t('namedAccountValidationRules', { ns: 'rates' });
    }

    return true;
  },
};

export const routeFromValidationRules = (
  routeToValues: string[] | string | null,
) => ({
  required: true,
  validate: (v: string[] | string | null) => {
    if (v && v.length > 1 && routeToValues && routeToValues.length > 1) {
      return t('routeTooManyValidation', { ns: 'rates' });
    }
  },
});

export const routeToValidationRules = (routeFromValues: string[]) => ({
  required: true,
  validate: (v: string[] | string | null) => {
    if (v && v.length > 1 && routeFromValues && routeFromValues.length > 1) {
      return t('routeTooManyValidation', { ns: 'rates' });
    }
  },
});
